import React, { useState } from "react";
import thirdpartyimg from "../../Assets/Images/thirdpartybanner.png";
import {
  MdKeyboardDoubleArrowDown,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

const ThirdPartySystem = () => {
  const [openIndex, setOpenIndex] = useState(null);

 const data = [
  {
    title: "CE Marking Compliance – European Conformity",
    content:
      "CE Marking compliance certifies that your products meet all EU health, safety, and environmental protection requirements, authorizing free sale across the European Economic Area.",
  },
  {
    title: "ROHS Compliance Certification – Restriction of Hazardous Substances",
    content:
      "ROHS compliance ensures your electrical and electronic products limit hazardous substances, promoting safer manufacturing and environmental protection.",
  },
  {
    title: "BIFMA Compliance Certification – Business and Institutional Furniture Manufacturers Association",
    content:
      "BIFMA certification verifies that your furniture products meet rigorous safety, durability, and sustainability standards established by the Business and Institutional Furniture Manufacturers Association.",
  },
  {
    title: "COC Compliance Certification – Certificate of Conformity",
    content:
      "Certificate of Conformity (COC) confirms that your products meet specified regulatory and quality requirements necessary for market entry and trade.",
  },
  {
    title: "HALAL Compliance Certification",
    content:
      " HALAL certification demonstrates that your products comply with Islamic dietary laws, ensuring they are permissible for consumption by Muslim consumers worldwide.",
  },
  {
    title: "KOSHER Compliance Certification",
    content:
      "KOSHER certification verifies that your products meet Jewish dietary laws, offering assurance of acceptability to consumers observing kosher practices.",
  },
  {
    title: "NEMA Compliance Certification – National Electrical Manufacturers Association",
    content:
      " NEMA certification validates that your electrical products conform to performance and safety standards developed by the National Electrical Manufacturers Association.",
  },
  {
    title: "REACH Compliance Certification – Registration, Evaluation, Authorisation, and Restriction of Chemicals",
    content:
      "REACH compliance confirms that your chemical substances meet EU Registration, Evaluation, Authorization, and Restriction of Chemicals regulations, ensuring safety and environmental protection.",
  },
  {
    title: "Certification of Conformity",
    content:
      "Certification of Conformity is an official attestation that your products fulfill specified national or international standards for quality, safety, and performance.",
  },
  {
    title: "Free Sale Certification",
    content:
      "Free Sale Certification guarantees that your exported products are legally sold and approved for sale in the country of origin, facilitating international trade access.",
  },
];


  const toggleContent = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="container">
      <div>
        <div className=" d-flex justify-content-around align-items-center  third-party-system">
          <h1 className="third-party-system-title">
            PRODUCT CERTIFICATION
          </h1>
          <p className="third-party-system-content">
            Our Third-Party System Inspection provides independent, unbiased{" "}
            <br />
            evaluations to ensure ISO compliance. We identify gaps, verify{" "}
            <br />
            processes, and strengthen your operational performance." <br />
          </p>
        </div>

        <div className="row third-party-banner-section">
          <div className="col-lg-7">
            {data.map((item, index) => (
              <div
                key={index}
                className={`third-party-option ${
                  openIndex === index ? "active" : ""
                }`}
              >
                <div
                  className="thirdparty-option-header"
                  onClick={() => toggleContent(index)}
                >
                  {openIndex === index ? (
                    <MdKeyboardDoubleArrowDown
                      size={22}
                      className="thirdparty-arrow-icon"
                    />
                  ) : (
                    <MdKeyboardDoubleArrowRight
                      size={22}
                      className="thirdparty-arrow-icon"
                    />
                  )}
                  <h2 className="third-party-question-title">{item.title}</h2>
                </div>

                {openIndex === index && (
                  <div className="third-party-question-content">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="col-lg-5">
            <img className="third-party-img" src={thirdpartyimg} alt="" />
          </div>
        </div>

      </div>
    </div>
  );
};

export default ThirdPartySystem;
